module.exports = __webpack_public_path__ + "static/media/bodies-1.17e02f3f.png";